module.exports = __webpack_public_path__ + "img/hearts.16e3793.png";